module.exports = __webpack_public_path__ + "fonts/materialdesignicons-webfont.bd5c85a.woff";